import React from 'react';
import { useParams } from 'react-router-dom';
import RecruitmentPlanJobList from './RecruitmentPlanJobList';

const RecruitmentPlanJobManagList = () => {

    const { planIdParam } = useParams();

    return (
        <RecruitmentPlanJobList recuitmentPlanId={planIdParam} type="CONDUCERE"/>
    );
};

export default RecruitmentPlanJobManagList;
